import React, { useState, useContext, useEffect } from "react";
import Button from "./Button";
import Header from "./Header";
import loadingGif from "../img/loading.gif";

import { AppContext } from "../context";
import {
  initializeEmail,
  setLog,
  userLogs,
  patLogs,
  setResumeFlowEmail,
  translateText,
  vinCheckDB,
  setHyundaiData,
  sethyudaiVinDisable,
  getKiwiValidationCheck,
  setinputMetaDataFlag,
  setinputMetaData,
  saveDetailsInRedis,
  getKiwiValidationCustomerFlow
} from "../context/utils";
import Navbar from "./Navbar";
import SafeImage from "./SafeImage";

// import * as Sentry from "@sentry/react";
// import ReactGA from "react-ga4";

let logsbugs = true;

const Email = () => {
  const {
    stepCovered,
    setStepCovered,
    setScreen,
    setUserEmail,
    clientId,
    token,
    inspectionId,
    config,
    showAlert,
    setCurrentPage,
    currentPage,
    setStartPing,
    inputMetaData
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;

  const mailFormat =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  const [email, setEmail] = useState("");
  const [commonDetailsEntery, setCommonDetailsEntery] = useState([]);
  const [checked, setChecked] = useState(false);
  const [screenHeight, setScreenHeight] = useState(land() ? false : true);
  // const [disable, setDisable] = useState(true);
  const [vinValidationCheck, setVinValidationCheck] = useState(
    clientId === "hc_pilot" ? true : false
  );
  const [kiwiValidationCheck, setKiwiValidationCheck] = useState(
    Object.keys(config["intro-page"]).includes("kiwi-validation-check") && getKiwiValidationCustomerFlow() ? true : false
  );
  const [commonDetailEntery, setCommonDetailEntery] = useState(
    Object.keys(config["intro-page"]).includes("common-detail-entry") ? true : false
  );
  const [loading, setLoading] = useState(false);
  const [vinInput, setVinInput] = useState("");
  const [registrationNoInput, setRegistrationNoInput] = useState("");
  const [odometerInput, setOdometerInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  logsbugs = false;
  const validateEmail = (e) => {
    setEmail(e.target.value);
  };

  const vinText = (e) => {
    setErrorMessage("");
    setVinInput(e.target.value);
  };

  const registrationNoText = (e) => {
    setErrorMessage("");
    setRegistrationNoInput(e.target.value);
  };

  const odometerText = (e) => {
    setErrorMessage("");
    setOdometerInput(e.target.value);
  };

  const isValid = () => {
    if (
      (!config["intro-page"]["show-privacy-policy"] ||
        config["intro-page"]["privacy-policy-type"] === "text") &&
      !config["intro-page"]["show-email-option"]
    ) {
      return true;
    } else if (
      (!config["intro-page"]["show-privacy-policy"] ||
        config["intro-page"]["privacy-policy-type"] === "text") &&
      config["intro-page"]["show-email-option"]
    ) {
      return mailFormat.test(email);
    } else if (
      config["intro-page"]["privacy-policy-type"] === "checkbox" &&
      config["intro-page"]["show-email-option"]
    ) {
      return mailFormat.test(email) && checked;
    } else if (
      config["intro-page"]["privacy-policy-type"] === "checkbox" &&
      !config["intro-page"]["show-email-option"]
    ) {
      return checked;
    } else return true;
  };

  window.onresize = () => {
    setScreenHeight(land() ? false : true);
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const onProceed = () => {
    //patLogs("Procced button is clicked", inspectionId);
    if (isValid()) {
      if (navigator.onLine) {
        patLogs(
          config["intro-page"]["show-email-option"]
            ? `Entered email -> ${email}`
            : "Email is not mandatory",
          inspectionId
        );
        // patLogs(
        //   config["intro-page"]["show-privacy-policy"]
        //     ? "checked Privacy Policy"
        //     : "Privacy Policy is not mandatory",
        //   inspectionId
        // );
        if(clientId === "client_1417" || clientId === "superapp_editor_test") {
        setUserEmail(config["userEmailreport"]);
        }else{
        setUserEmail(email);
        }
        initializeEmail(email);
        if (Object.keys(config).includes("resumeFlow")) {
          setResumeFlowEmail(inspectionId, email);
        }
        setScreen("instructions");
        setEmail("");
      }
    } else {
      patLogs(`this email ${email} is not valid`, inspectionId);
    }
  };

  const isOnlyDigits = (value) => {
    try {
      const val = Number(value);
      return /^\d+$/.test(val);
    }
    catch (err) {
      // console.log("err in odometer: ", err)
      return false;
    }
  };

  const commonDetailsProceed = () => {
    try {
      let validationFailed = false;
      config["intro-page"]["common-detail-entry"].forEach((item) => {
        const index = commonDetailsEntery.findIndex((data) => data.name === item["name"]);
        // console.log("index: ", index, "value: ", commonDetailsEntery[index] ? commonDetailsEntery[index]["value"] : "no value");
        if (index === -1 || !commonDetailsEntery[index]["value"] || commonDetailsEntery[index]["value"].trim() === "") {
          setErrorMessage(item["error-message"] ? item["error-message"] : getTranslateText("Please enter") + ` ${item["name"]}`);
          validationFailed = true;
          return;
        }
      });
      if (validationFailed) return;
      setErrorMessage("");
      setLoading(true);
      //Todo: SAVE THE DETAILS IN db OR REDIS
      config["intro-page"]["common-detail-entry"].forEach((item) => {
        const index = commonDetailsEntery.findIndex((data) => data.name === item["name"]);
        if (item["save-in"] && item["save-in"] === "inputMetaData" && index > -1) {
          setinputMetaDataFlag(true);
          const tempInputMetaData = inputMetaData ? { ...inputMetaData } : {};
          tempInputMetaData[item["name"]] = commonDetailsEntery[index]["value"];
          setinputMetaData(tempInputMetaData);
        }
        else if (item["save-in"] && item["save-in"] === "redis" && index > -1) {
          saveDetailsInRedis({ key: item["name"], value: commonDetailsEntery[index]["value"], inspectionId: inspectionId });
        }
        else if (item["save-in"] && Array.isArray(item["save-in"]) && index > -1) {
          setinputMetaDataFlag(true);
          const tempInputMetaData = inputMetaData ? { ...inputMetaData } : {};
          tempInputMetaData[item["name"]] = commonDetailsEntery[index]["value"];
          setinputMetaData(tempInputMetaData);
          saveDetailsInRedis({ key: item["name"], value: commonDetailsEntery[index]["value"], inspectionId: inspectionId });
        }
      });

      if (Object.keys(config["intro-page"]).includes("common-detail-entry-skip-email") && config["intro-page"]["common-detail-entry-skip-email"]) setScreen("instructions");
      else setCommonDetailEntery(false);
      setLoading(false);

    } catch (err) {
      // console.log("Error in commonDetailsProceed: ", err);
      setLoading(false);
      setErrorMessage(getTranslateText("Something went wrong. Please try again."));
    }
  }

  const kiwiValidation = async () => {
    try {
      if ((!Object.keys(config["intro-page"]).includes("kiwi-validation-check-customer-flow") || (Object.keys(config["intro-page"]).includes("kiwi-validation-check-customer-flow") && !config["intro-page"]["kiwi-validation-check-customer-flow"])) && !registrationNoInput.length > 0) {
        setErrorMessage(getTranslateText("Please enter registration Number"));
        return;
      }
      if ((getKiwiValidationCheck()[0] == null || (getKiwiValidationCheck()[0] && !Object.keys(getKiwiValidationCheck()[0]).includes("odometer")) || (getKiwiValidationCheck()[0] && Object.keys(getKiwiValidationCheck()[0]).includes("odometer") && (getKiwiValidationCheck()[0]["odometer"] === "" || getKiwiValidationCheck()[0]["odometer"] === null))) && !odometerInput.length > 0) {
        setErrorMessage(getTranslateText("Please enter odometer"));
        return;
      }
      if ((getKiwiValidationCheck()[0] == null || (getKiwiValidationCheck()[0] && !Object.keys(getKiwiValidationCheck()[0]).includes("odometer")) || (getKiwiValidationCheck()[0] && Object.keys(getKiwiValidationCheck()[0]).includes("odometer") && (getKiwiValidationCheck()[0]["odometer"] === "" || getKiwiValidationCheck()[0]["odometer"] === null))) && odometerInput.length > 0 && !isOnlyDigits(odometerInput)) {
        setErrorMessage(getTranslateText("Odometer should contains digit only"));
        return;
      }

      setErrorMessage("");
      setLoading(true);
      if (Object.keys(config["intro-page"]).includes("kiwi-validation-check-customer-flow") || (getKiwiValidationCheck() && getKiwiValidationCheck().length > 0 && getKiwiValidationCheck()[1])) {
        if ((!Object.keys(config["intro-page"]).includes("kiwi-validation-check-customer-flow")) && getKiwiValidationCheck()[1].toLowerCase() !== registrationNoInput.toLowerCase()) {
          setLoading(false);
          setErrorMessage(getTranslateText("You have entered the wrong registration number"));
        }
        else {
          if ((getKiwiValidationCheck()[0] && !Object.keys(getKiwiValidationCheck()[0]).includes("odometer")) || (getKiwiValidationCheck()[0] && Object.keys(getKiwiValidationCheck()[0]).includes("odometer") && (getKiwiValidationCheck()[0]["odometer"] === "" || getKiwiValidationCheck()[0]["odometer"] === null))) {
            setinputMetaDataFlag(true);
            const tempInputMetaData = getKiwiValidationCheck()[0];
            tempInputMetaData["odometer"] = odometerInput;
            setinputMetaData(tempInputMetaData);
          }
          if (Object.keys(config["intro-page"]).includes("kiwi-validation-check-skip-email") && config["intro-page"]["kiwi-validation-check-skip-email"]) setScreen("instructions");
          else setKiwiValidationCheck(false);
          setLoading(false);
        }
      }
      else {
        setLoading(false);
        setErrorMessage(getTranslateText("Registration Number validation failed! Please contact adiminstration"));
      }
    }
    catch (err) {
      // console.log(err);
      setLoading(false);
      setErrorMessage(getTranslateText("Registration Number validation failed! Please contact adiminstration"));
    }
  }

  const commonDetailsHandler = (e, item) => {
    setErrorMessage("");
    let temp = [...commonDetailsEntery];
    const index = temp.findIndex((data) => data.name === item["name"]);
    if (index > -1) {
      temp[index]["value"] = e.target.value;
    }
    else {
      temp.push({ name: item["name"], value: e.target.value });
    }
    setCommonDetailsEntery(temp);
  }

  const vinCheck = async () => {
    if (!vinInput.length > 0) {
      setErrorMessage("Please enter VIN");
      return;
    }
    setErrorMessage("");
    setLoading(true);
    let value = await vinCheckDB(vinInput.trim());
    // console.log(value);
    if (value.status === true) {
      let hyundaiVin = Object.keys(value.message).includes("used")
        ? value.message["used"]
        : 0;
      if (hyundaiVin === 0) {
        setHyundaiData(value.message);
        setVinValidationCheck(false);
        sethyudaiVinDisable(vinInput.trim())
        setLoading(false);
      } else {
        setLoading(false);
        setErrorMessage("Inspection for this VIN has been completed.");
      }
    } else {
      setLoading(false);
      setErrorMessage(value.message);
    }
  };

  useEffect(() => {
    patLogs("Entered to email page", inspectionId);
    userLogs({
      position: 8,
      last_page: "email page",
      inspectionId: inspectionId,
    });
    if (Object.keys(config["intro-page"]).includes("kiwi-validation-check") && !getKiwiValidationCustomerFlow()) setScreen("instructions");
  }, []);

  return (
    <div
      className="screen_email"
      style={{
        height: screenHeight ? "100dvh" : "",
        position: screenHeight ? "relative" : "",
        padding: screenHeight ? "0%" : "",
      }}
    >
      <Navbar />
      {vinValidationCheck ? (
        <div className="HyundaiVInDIv">
          <input
            id="VIN"
            name="VIN"
            type="text"
            style={{ width: "80%", marginTop: "10%" }}
            onInput={vinText}
            value={vinInput}
            placeholder={"Enter your VIN"}
            required
          />
          <div className="vinButtonHyundaicanada">
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            {loading === false ? (
              <Button
                disabled={false}
                wide={true}
                onclick={vinCheck}
                text={"VIN Validation"}
              />
            ) : (
              <img style={{ width: "36px" }} src={loadingGif} />
            )}
          </div>
        </div>
      ) : kiwiValidationCheck ? (
        <>
          <div className="HyundaiVInDIv" style={{ height: "90dvh" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "10% 1% 10% 7%", gap: "10%" }}>
              <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                <SafeImage style={{ width: "100px" }} src={config["intro-page"]["image"]} />
              </div>
              {
                getKiwiValidationCheck()[0] && Object.keys(getKiwiValidationCheck()[0]).includes("QCRemarks") && getKiwiValidationCheck()[0]["QCRemarks"] !== "" &&
                <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "2%", alignItems: "center", justifyContent: "center" }}>
                  <label className="label" style={{ margin: "0px", padding: "2px 0px 0px 0px", fontSize: "16px", fontWeight: "bold" }}>
                    {config["intro-page"]["OQ-remark-text"] ? config["intro-page"]["OQ-remark-text"] : getTranslateText("QC Remark:")}</label>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "20px", fontWeight: "bold", color: config["colors"]["btn"] }}>{getTranslateText(getKiwiValidationCheck()[0]["QCRemarks"])}</p>
                </div>
              }
              {
                (!Object.keys(config["intro-page"]).includes("kiwi-validation-check-customer-flow") || (Object.keys(config["intro-page"]).includes("kiwi-validation-check-customer-flow") && !config["intro-page"]["kiwi-validation-check-customer-flow"])) &&
                <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5%" }}>
                  <label className="label" style={{ margin: "0px", padding: "0px", fontSize: "16px", fontWeight: "bold" }}>
                    {getTranslateText("Enter Registration Number")}{" "}<span>*</span></label>
                  <input
                    id="VIN"
                    name="registrationNo"
                    type="text"
                    style={{ width: "80%", margin: "unset" }}
                    onInput={registrationNoText}
                    value={registrationNoInput}
                    placeholder={getTranslateText("Registration Number")}
                    required
                  />
                </div>
              }
              {(getKiwiValidationCheck()[0] === null || !Object.keys(getKiwiValidationCheck()[0]).includes("odometer") || getKiwiValidationCheck()[0]["odometer"] === "" || getKiwiValidationCheck()[0]["odometer"] === null) &&
                <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5%" }}>
                  <label className="label" style={{ margin: "0px", padding: "0px", fontSize: "16px", fontWeight: "bold" }}>
                    {getTranslateText("Enter Odometer Reading")}{" "}<span>*</span></label>
                  <input
                    id="VIN"
                    name="odometer"
                    type="text"
                    style={{ width: "80%", margin: "unset" }}
                    onInput={odometerText}
                    value={odometerInput}
                    placeholder={getTranslateText("Odometer Reading")}
                    required
                  />
                </div>
              }
            </div>
            <div className="vinButtonHyundaicanada">
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              {loading === false ? (
                <Button
                  disabled={false}
                  wide={true}
                  onclick={kiwiValidation}
                  text={getTranslateText("Proceed")}
                />
              ) : (
                <img style={{ width: "36px" }} src={loadingGif} />
              )}
            </div>
          </div>
        </>
      ) : commonDetailEntery ? (
        <>
          <div className="HyundaiVInDIv" style={{ height: "90dvh" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "10% 1% 10% 7%", gap: "10%" }}>
              <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                <SafeImage style={{ width: "100px" }} src={config["intro-page"]["image"]} />
              </div>
              {
                config["intro-page"]["common-detail-entry"].map((item, index) => (
                  <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5%" }}>
                    <label className="label" style={{ margin: "0px", padding: "0px", fontSize: "16px", fontWeight: "bold" }}>
                      {item["label"]}{" "}<span>*</span></label>
                    <input
                      id="VIN"
                      key={item["name"]}
                      name={item["name"]}
                      type="text"
                      style={{ width: "80%", margin: "unset" }}
                      onInput={(e) => commonDetailsHandler(e, item)}
                      value={commonDetailsEntery[index] ? commonDetailsEntery[index]["value"] : ""}
                      placeholder={item["placeholder"] ? item["placeholder"] : `Enter ${item["name"]}`}
                      required
                    />
                  </div>
                ))
              }
            </div>
            <div className="vinButtonHyundaicanada">
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              {loading === false ? (
                <Button
                  disabled={false}
                  wide={true}
                  onclick={commonDetailsProceed}
                  text={getTranslateText("Proceed")}
                />
              ) : (
                <img style={{ width: "36px" }} src={loadingGif} />
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            id="screen1"
            className="email_screen"
            style={{
              height: screenHeight ? "70vh" : "",
              justifyContent: screenHeight ? "space-evenly" : "",
            }}
          >
            <Header />
            <SafeImage src={config["intro-page"]["image"]} />
            {config["intro-page"]["show-email-option"] ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h2 className="header2">
                  {config["intro-page"]["email-text"]}
                </h2>
                <div className="form">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    style={{ width: "80%" }}
                    onInput={validateEmail}
                    value={email}
                    placeholder={config["intro-page"]["placeholder"]}
                    required
                  />
                </div>
              </div>
            ) : null}
            {config["intro-page"]["show-privacy-policy"] ? (
              config["intro-page"]["privacy-policy-type"] === "text" ? (
                <h2
                  style={{ textDecoration: "underline", color: "#006cca" }}
                  onClick={() => {
                    window.location.href =
                      config["intro-page"]["privacy-policy-link"];
                  }}
                >
                  {config["intro-page"]["privacy-policy-text"]}
                </h2>
              ) : config["intro-page"]["privacy-policy-type"] === "checkbox" ? (
                <div className="email-checkbox">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                  />
                  {config["intro-page"]["privacy-policy-link"] === "" ? (
                    <h4 style={{ color: "#006cca" }}>
                      {config["intro-page"]["privacy-policy-text"]}
                    </h4>
                  ) : (
                    <h4
                      style={{ textDecoration: "underline", color: "#006cca" }}
                      onClick={() => {
                        window.location.href =
                          config["intro-page"]["privacy-policy-link"];
                      }}
                    >
                      {config["intro-page"]["privacy-policy-text"]}
                    </h4>
                  )}
                </div>
              ) : null
            ) : null}
            <div className="InternetWarning">
              <p>{showAlert && showAlert}</p>
            </div>
          </div>
          {["clientopt.02.2", ""].includes(clientId) && (
            <div className="powerByLogo">
              <p style={{ opacity: 0.5 }}>
                {config["powerByText"] ? config["powerByText"] : "powered by"}
              </p>
              <SafeImage
                style={{ width: "25%" }}
                alt="123"
                src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/client-icon%26logo/client_898-logo.png"
                fallback={null}
              />
            </div>
          )}
          <div
            className="email_btn"
            style={{
              height: screenHeight ? "auto" : "",
              position: screenHeight ? "absolute" : "",
              bottom: screenHeight ? "10px" : "",
              padding: screenHeight ? "0px 2px" : "",
            }}
          >
            <Button
              disabled={!isValid()}
              wide={true}
              onclick={onProceed}
              text={config["intro-page"]["btn-text"]}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Email;
